export const insertTCFScript = ({ id = 'dzr-gdpr-script', botUA, scriptUrl })=>{
    if (botUA && new RegExp(botUA, 'i').test(navigator.userAgent) || document.getElementById(id)) {
        return;
    }
    const gdprScript = document.createElement('script');
    gdprScript.async = true;
    gdprScript.crossOrigin = 'anonymous';
    gdprScript.defer = true;
    gdprScript.id = id;
    gdprScript.src = scriptUrl;
    document.head.appendChild(gdprScript);
};
export const initGDPRCallback = async (initApi, options)=>{
    window.consentScreenApi = await initApi(options);
};

//# sourceMappingURL=utils.js.map